module.exports = __webpack_public_path__ + "img/pantalla2-1.76cf0bed.png";